import React, { FC } from 'react';
import { Configuration } from 'api/notifications';
import {
  isDateField,
  isFollowable,
  isReminder,
} from 'api/notifications/configuration';
import { Mandatory } from '../../group';
import { DateFieldConfigurationView } from './date';
import { FollowableConfigurationView } from './followable';
import { ReminderConfigurationView } from './reminder';
import { SimpleConfigurationView } from './simple';

export interface ConfigurationProps {
  configuration: Configuration;
  mandatory?: Mandatory;
  onChange: (configuration: Configuration) => void;
}

export const ConfigurationView: FC<ConfigurationProps> = ({
  configuration,
  mandatory,
  onChange,
}) => {
  const mandatoryConfig = mandatory?.channels;
  const isMandatory = !!mandatory;

  return isReminder(configuration) ? (
    <ReminderConfigurationView
      configuration={configuration}
      mandatory={isMandatory}
      mandatoryConfig={mandatoryConfig}
      onChange={onChange}
    />
  ) : isFollowable(configuration) ? (
    <FollowableConfigurationView
      configuration={configuration}
      mandatory={isMandatory}
      mandatoryConfig={mandatoryConfig}
      onChange={onChange}
    />
  ) : isDateField(configuration) ? (
    <DateFieldConfigurationView
      configuration={configuration}
      mandatory={isMandatory}
      mandatoryConfig={mandatoryConfig}
      onChange={onChange}
    />
  ) : (
    <SimpleConfigurationView
      configuration={configuration}
      mandatory={isMandatory}
      mandatoryConfig={mandatoryConfig}
      onChange={onChange}
    />
  );
};
